/* eslint-disable react-hooks/rules-of-hooks */
import './StartBotSelector.pcss';
import React from 'react';
import classNames from 'classnames';
import { createContainer, Container } from 'unstated-next';
import {
  useStartBotOptions,
  useStartBotAdsOptions,
  useStartBotSMOptions,
} from './use-start-bot-options';
import { Suggestion } from './types';
import { useConfirmModalHandler } from './use-confirm-modal-handler';
import Spinner from '../../../../../common/components/Spinner';
import PrimarySelect, {
  DropdownOption,
  OrganizedDropdownOption,
} from '../../../../../common/components/PrimarySelect/PrimarySelect';

export const StartBotSponsoredSelectContainer =
  createContainer(useStartBotSMOptions);
export const StartBotSelectContainer = createContainer(useStartBotOptions);
export const StartBotAdsSelectContainer = createContainer(
  useStartBotAdsOptions,
);

type Value = {
  isLoading: boolean;
} & (
  | {
      options: DropdownOption[];
      organizedOptions?: OrganizedDropdownOption[];
    }
  | {
      options?: DropdownOption[];
      organizedOptions: OrganizedDropdownOption[];
    }
);

type Props = {
  title?: string;
  className?: string;
  onBotSelect?: (pageId: number, v: Suggestion) => void;
};

const StartBotSelectView = (props: Props & { container: Container<Value> }) => {
  const {
    className,
    container,
    onBotSelect,
    title = 'Copy an existing dialogue',
  } = props;

  const { isLoading, options, organizedOptions } = container.useContainer();

  const { openConfirmModal } = useConfirmModalHandler();
  const onSelectChange = (opt: Suggestion) =>
    openConfirmModal(opt, onBotSelect);

  const headingStyles = { display: 'block', marginBottom: 10 };

  return (
    <div className={classNames('start-bot-select-view', className)}>
      <span style={headingStyles}>{title}</span>
      {isLoading ? (
        <Spinner
          show={true}
          position="unset"
          size={24}
          backgroundColor="white"
        />
      ) : (
        <PrimarySelect
          organizedOptions={organizedOptions}
          options={options}
          onChange={onSelectChange}
          placeholder="Select Dialogue"
          showSearchFilter={true}
        />
      )}
    </div>
  );
};

export const StartBotSponsoredSelector = (props: Props) => {
  return (
    <StartBotSponsoredSelectContainer.Provider>
      <StartBotSelectView
        container={StartBotSponsoredSelectContainer}
        {...props}
      />
    </StartBotSponsoredSelectContainer.Provider>
  );
};

export const StartBotAdsSelector = (props: Props) => {
  return (
    <StartBotAdsSelectContainer.Provider>
      <StartBotSelectView container={StartBotAdsSelectContainer} {...props} />
    </StartBotAdsSelectContainer.Provider>
  );
};

export const StartBotSelector = (props: Props) => {
  return (
    <StartBotSelectContainer.Provider>
      <StartBotSelectView container={StartBotSelectContainer} {...props} />
    </StartBotSelectContainer.Provider>
  );
};

export const DialogueSelector = (props: Props) => {
  return (
    <StartBotSelectContainer.Provider>
      <StartBotSelectView container={StartBotSelectContainer} {...props} />
    </StartBotSelectContainer.Provider>
  );
};
